var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgToggle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "25pt",
    height: "19pt",
    viewBox: "0 0 65 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 47.734375 35 L 17.265625 35 C 7.730469 35 0 27.164062 0 17.5 C 0 7.835938 7.730469 0 17.265625 0 L 47.734375 0 C 57.269531 0 65 7.835938 65 17.5 C 65 27.164062 57.269531 35 47.734375 35 Z M 47.734375 35 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(5 5 190)",
      fillOpacity: 1
    },
    d: "M 47.734375 35 L 17.265625 35 C 7.730469 35 0 27.164062 0 17.5 C 0 7.835938 7.730469 0 17.265625 0 L 47.734375 0 C 57.269531 0 65 7.835938 65 17.5 C 65 27.164062 57.269531 35 47.734375 35 Z M 17.265625 2.058594 C 8.851562 2.058594 2.03125 8.972656 2.03125 17.5 C 2.03125 26.027344 8.851562 32.941406 17.265625 32.941406 L 47.734375 32.941406 C 56.148438 32.941406 62.96875 26.027344 62.96875 17.5 C 62.96875 8.972656 56.148438 2.058594 47.734375 2.058594 Z M 17.265625 2.058594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(5 5 190)",
      fillOpacity: 1
    },
    d: "M 34.53125 17.5 C 34.53125 27.164062 26.800781 35 17.265625 35 C 7.730469 35 0 27.164062 0 17.5 C 0 7.835938 7.730469 0 17.265625 0 C 26.800781 0 34.53125 7.835938 34.53125 17.5 Z M 34.53125 17.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 17.265625 35 C 7.730469 35 0 27.164062 0 17.5 C 0 7.835938 7.730469 0 17.265625 0 C 26.800781 0 34.53125 7.835938 34.53125 17.5 C 34.519531 27.160156 26.796875 34.988281 17.265625 35 Z M 17.265625 2.058594 C 8.851562 2.058594 2.03125 8.972656 2.03125 17.5 C 2.03125 26.027344 8.851562 32.941406 17.265625 32.941406 C 25.679688 32.941406 32.5 26.027344 32.5 17.5 C 32.488281 8.976562 25.675781 2.070312 17.265625 2.058594 Z M 17.265625 2.058594 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggle);
export default __webpack_public_path__ + "static/media/toggle.77c739f1.svg";
export { ForwardRef as ReactComponent };